;(function () {
  const MODEL_PARAM = "filter.v.m.custom.vehicle_model"
  const YEAR_PARAM = "filter.v.m.custom.vehicle_year"

  const config = { models: {} }

  try {
    const el = document.querySelector("[data-vehicle-fitment-map]")
    if (el) {
      const parsed = JSON.parse(el.textContent)
      if (parsed && typeof parsed === "object") {
        if (parsed.models && typeof parsed.models === "object") {
          config.models = parsed.models
        }
      }
    }
  } catch {
    /* fall back to defaults — feature degrades to "no constraint" */
  }

  // Returns the configured valid years for a model, or null when the model has
  // no constraint (blank setting) — null means "all years allowed".
  const validYearsFor = (model) => {
    if (typeof model !== "string") return null
    const years = config.models[model.toLowerCase()]
    if (!Array.isArray(years) || years.length === 0) return null
    return years.map(String)
  }

  // Inverse lookup: which models are valid for a given year. Returns null when
  // no model has any constraint configured.
  const validModelsFor = (year) => {
    if (year == null) return null
    const target = String(year)
    const models = []
    let anyConfigured = false

    Object.keys(config.models).forEach((model) => {
      const years = config.models[model]
      if (Array.isArray(years) && years.length > 0) {
        anyConfigured = true
        if (years.map(String).indexOf(target) !== -1) models.push(model)
      } else {
        models.push(model)
      }
    })

    return anyConfigured ? models : null
  }

  const isValidCombo = (model, year) => {
    if (!model || !year) return true
    const years = validYearsFor(model)
    if (!years) return true
    return years.indexOf(String(year)) !== -1
  }

  // Append a single model/year selection to params.
  const applyParams = (params, model, year) => {
    if (model) params.append(MODEL_PARAM, model)
    if (year) params.append(YEAR_PARAM, year)
    return params
  }

  window.RivianVehicleFitment = Object.freeze({
    MODEL_PARAM,
    YEAR_PARAM,
    validYearsFor,
    validModelsFor,
    isValidCombo,
    applyParams,
  })
})()
